export const ORDER_AWAITING_PAYMENT_STATUS = '61bfbba93487962b0264b0ff'